import { instance } from "libs/api";

import { ApiRoutesTransfers } from "../../constants";
import { TransferSummary } from "../../transfers.types";

export const requestGetTransferSummary = async (): Promise<TransferSummary> => {
  return await instance.get(`${ApiRoutesTransfers.Transfers}/summary`);
};
